<script>
export default {
    name: "FooterArrowRightSvg"
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="171.816" height="18.385" viewBox="0 0 171.816 18.385">
        <g id="Group_965" data-name="Group 965" transform="translate(-1000.609 -10820.34)">
            <g id="Polygon_14" data-name="Polygon 14" transform="translate(1172.426 10820.34) rotate(90)" fill="none">
                <path d="M9.192,0l9.192,15.627H0Z" stroke="none"/>
                <path d="M 9.192156791687012 1.972292900085449 L 1.7484130859375 14.6265983581543 L 16.63590049743652 14.6265983581543 L 9.192156791687012 1.972292900085449 M 9.192156791687012 -1.9073486328125e-06 L 18.38431739807129 15.6265983581543 L -3.814697265625e-06 15.6265983581543 L 9.192156791687012 -1.9073486328125e-06 Z" stroke="none" fill="#fff"/>
            </g>
            <path id="Path_1096" data-name="Path 1096" d="M171.357,0H0" transform="translate(1000.609 10829.532)" fill="none" stroke="#fff" stroke-width="1"/>
        </g>
    </svg>
</template>
